import React from 'react';

import TEXT from '../../../../../../data/text.json';

import TextBox from '../../../form-components/text-box';
import TextArea from '../../../form-components/text-area';
import DropDown from '../../../form-components/drop-down';

export default ({
  itemNameValue,
  setItemNameValue,
  itemTypeValue,
  setItemTypeValue,
  itemDescValue,
  setItemDescValue
}) => (
  <div>
    <TextBox
      required
      id={TEXT.FORMS.itemNameId}
      label={TEXT.FORMS.itemNameLabel}
      placeholder={TEXT.FORMS.itemNamePlaceholder}
      value={itemNameValue}
      onChange={setItemNameValue}
    />

    <DropDown
      required
      id={TEXT.FORMS.itemTypeId}
      label={TEXT.FORMS.itemTypeLabel}
      selectedValue={itemTypeValue}
      onChange={setItemTypeValue}
      options={[
        { text: TEXT.FORMS.itemTypePlaceholder, value: '' },
        { text: 'Tableware Glass', value: 'TABLEWARE' },
        { text: 'Stained Glass Window', value: 'WINDOW' }
      ]}
    />

    <TextArea
      id={TEXT.FORMS.itemDescId}
      label={TEXT.FORMS.itemDescLabel}
      placeholder={TEXT.FORMS.itemDescPlaceholder}
      value={itemDescValue}
      onChange={setItemDescValue}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/new-item-form/stage-1/index.js